import { GraftConfig as GatewaysGraftConfig } from '@graft/nuget-gc.webportals.gateways'

import { readGraftWebserviceUrl } from '@common/core/config/utils/read-graft-webservice-url.util'

const gatewaysUrl = readGraftWebserviceUrl('GATEWAYS')

if (gatewaysUrl) {
  GatewaysGraftConfig.host = gatewaysUrl
  GatewaysGraftConfig.stateless = true
}
